import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import { NamedObservable } from "../helpers";
export var Repository =
/*#__PURE__*/
function (_NamedObservable) {
  _inherits(Repository, _NamedObservable);

  function Repository() {
    _classCallCheck(this, Repository);

    return _possibleConstructorReturn(this, _getPrototypeOf(Repository).apply(this, arguments));
  }

  _createClass(Repository, [{
    key: "saveItem",
    value: function saveItem(name, item) {
      if (item) {
        localStorage.setItem(name, item);
      } else {
        localStorage.removeItem(name);
      }

      this.notifyChange(name, item);
    }
  }, {
    key: "retrieveItem",
    value: function retrieveItem(name) {
      return localStorage.getItem(name);
    }
  }, {
    key: "saveObject",
    value: function saveObject(name, object) {
      if (object) {
        localStorage.setItem(name, JSON.stringify(object));
      } else {
        localStorage.removeItem(name);
      }

      this.notifyChange(name, object);
    }
  }, {
    key: "retrieveObject",
    value: function retrieveObject(name) {
      var item = localStorage.getItem(name);

      if (item) {
        return JSON.parse(item);
      }

      return null;
    }
  }]);

  return Repository;
}(NamedObservable);